import React from 'react'
import UninstallPage from '../uninstall'

const UninstallPageDe = () => {
    return <UninstallPage languageCode="de" />
}

export default UninstallPageDe
